import { render, staticRenderFns } from "./Test31.vue?vue&type=template&id=c09b4860&scoped=true&"
import script from "./Test31.vue?vue&type=script&lang=js&"
export * from "./Test31.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./Test31.vue?vue&type=style&index=1&id=c09b4860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09b4860",
  null
  
)

export default component.exports